<template>
  <modal :show="true" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Edit Driver Driver</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="type_id"
            :options="types"
            v-model="form.type_id"
            label="Driver Type"
            placeholder="Please Select"
          ></selectlist>

          <inputbox
            v-model="form.name"
            name="name"
            label="Driver Name"
          ></inputbox>

          <date-of-birth
            v-model="form.date_of_birth"
            :value="form.date_of_birth"
          ></date-of-birth>

          <spinner v-model="form.convictions" label="Convictions"></spinner>

          <spinner v-model="form.points" label="Points"></spinner>

          <input-block
            name="conviction_details"
            label="Conviction Details"
            v-model="form.conviction_details"
          ></input-block>

          <spinner
            v-model="form.accidents_in_three_years"
            label="Accidents Within The Last Three Years"
          ></spinner>

          <inputbox
            name="driving_licence"
            label="Driving Licence Number"
            v-model="form.licence_number"
          ></inputbox>

          <div class="form-group">
            <label for="issued_at" class="col-lg-2 control-label"
              >Issue Date</label
            >
            <div class="col-lg-10">
              <datepicker
                format="dd/MM/yyyy"
                :value="form.issue_date"
                v-on:selected="setIssuedAtDate"
                input-class="form-control"
                placeholder="dd/mm/yyyy"
              ></datepicker>
            </div>
          </div>

          <div class="form-group">
            <label for="expires_at" class="col-lg-2 control-label"
              >Expiry Date</label
            >
            <div class="col-lg-10">
              <datepicker
                format="dd/MM/yyyy"
                :value="form.expiry_date"
                v-on:selected="setExpiresAtDate"
                input-class="form-control"
                placeholder="dd/mm/yyyy"
              ></datepicker>
            </div>
          </div>

          <inputbox v-model="form.city" name="city" label="City"></inputbox>

          <toggleswitch
            :labels="true"
            name="had_proposal_declined"
            label="Proposal Declined?"
            v-model="form.had_proposal_declined"
          ></toggleswitch>

          <toggleswitch
            :labels="true"
            name="has_uk_licence"
            label="UK Licence?"
            v-model="form.has_uk_licence"
          ></toggleswitch>

          <toggleswitch
            :labels="true"
            name="has_new_licence"
            label="Licence Less Than 12 Months Old?"
            v-model="form.has_new_licence"
          ></toggleswitch>
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="float-left">
        <form-button
          :indicator="indicator"
          v-on:clicked="deleteDriver"
          level="danger"
          >Delete</form-button
        >
      </div>
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button :indicator="form.processing()" v-on:clicked="addDriver"
        >Update Driver</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    hire: {
      type: String
    },

    types: {
      type: Array,
      required: true
    },

    client: {
      type: Object
    },

    driver: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      indicator: false,
      form: new window.Form({
        type_id: this.driver.type_id,
        name: this.driver.name,
        date_of_birth: this.driver.date_of_birth
          ? window.DateManager.format(this.driver.date_of_birth)
          : null,
        convictions: this.driver.convictions,
        points: this.driver.points,
        conviction_details: this.driver.conviction_details,
        accidents_in_three_years: this.driver.accidents_in_three_years,
        licence_number: this.driver.licence_number,
        issue_date: this.driver.issue_date
          ? window.DateManager.format(this.driver.issue_date)
          : null,
        expiry_date: this.driver.expiry_date
          ? window.DateManager.format(this.driver.expiry_date)
          : null,
        city: this.driver.city,
        had_proposal_declined: this.driver.had_proposal_declined,
        has_uk_licence: this.driver.has_uk_licence,
        has_new_licence: this.driver.has_new_licence
      })
    };
  },

  methods: {
    deleteDriver() {
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.indicator = true;
            window.Ajax.delete(
              '/hires/' + this.hire + '/drivers/' + this.driver.identifier
            )
              .then(response => {
                this.$emit('deleted', this.driver);
                this.indicator = false;
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error deleting the driver.'
                );
              });
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    closeModal() {
      this.$emit('close');
    },

    addDriver() {
      this.form
        .put('/hires/' + this.hire + '/drivers/' + this.driver.identifier)
        .then(response => {
          this.$emit('updated', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error updating the driver.'
          );
        });
    },

    setIssuedAtDate(date) {
      this.form.issue_date = date;
    },

    setExpiresAtDate(date) {
      this.form.expiry_date = date;
    }
  }
};
</script>
